/**
 * Voidex Contract Addresses
 * Network: Base Sepolia (Chain ID: 84532)
 * Deployment: full-pretge-v1 (2026-01-31)
 * All core contracts deployed behind ERC1967Proxy (UUPS pattern).
 */

export const BASE_SEPOLIA_CHAIN_ID = 84532;

export const CONTRACTS = {
	/** Base Sepolia Deployment */
	baseSepolia: {
		/** VOID Token - ERC20 with permit (1B max supply) */
		voidToken: "0xe066812B1F5576Da75747417991dC08490D7cCB7",

		/** ShipNFT - ERC721 ships with tier support */
		shipNFT: "0x988f52863240299525e0f246f85Bb97bD5597F46",

		/** PreTGEFarming - Pre-TGE points farming with Chainlink VRF V2.5 (UUPS proxy) */
		preTgeFarming: "0xA49D20C87503c4A750a7A901355985dc60b0aF04",

		/** ORE Token - Farmed material resource */
		oreToken: "0x81F50613fd94dc9953A7a487Cd1995988906dd13",

		/** FLUX Token - Farmed energy resource */
		fluxToken: "0x663e9Ca7E0f8B0f5B375Ead39b3342b4E060dCE1",

		/** SystemTokenFactory - Creates per-system tokens via CREATE2 */
		systemTokenFactory: "0x3189b9Ac9666F3c9734A1d516C4213Cd6B357B82",

		/** SovereignManagerFactory - Creates sovereign managers (UUPS proxy) */
		sovereignManagerFactory: "0xFA11e6C5d5DF8A1f1c0f138c77360d389C0B0e68",

		/** BondingCurveFactory - Creates bonding curves (UUPS proxy) */
		bondingCurveFactory: "0x2E615d464571705c92CE1010017b26a62a9B9F61",

		/** SystemRegistry - Central system registry (UUPS proxy) */
		systemRegistry: "0x7691011E0F8c074bffef716c4b016930F6193c41",

		/** PlanetRegistry - Central planet registry (UUPS proxy) */
		planetRegistry: "0xf51e865ba20066846f5c0a45308859cCC1e6248A",

		/** SovereigntyEngine - Sovereignty mechanics (UUPS proxy) */
		sovereigntyEngine: "0x8aE7ACfCDC47764fa3a2C474FC6DC3EEFB70DaBc",

		/** FeeRouter - Protocol fee distribution (UUPS proxy) */
		feeRouter: "0xd0b2dBFEB399ce1b7A6606b85b92f527B617E267",

		/** TerraformingEngine - Planet restoration via VOID burns (UUPS proxy) */
		terraformingEngine: "0x789e1C512BE9B29fD5413Dd9Bf6b3499c1F03Ff6",

		/** PlanetAuction - Dutch & English auctions for planet shares (UUPS proxy) */
		planetAuction: "0xd100BAb59e2b40bC8b919712c73B50C48698e4B6",

		/** FarmingEngine - VRF-powered planet farming (UUPS proxy) */
		farmingEngine: "0x20a821b099DE6cC22F11bFDCBBB34A7aaDA8D78F",

		/** Treasury - Protocol treasury */
		treasury: "0xda97ee9946E18D8b2791063Ad5D0232E494C617F",

		/** MockUSDC - Payment token for ship purchases (6 decimals) */
		usdc: "0xad7D9182F49e1c427dC56e5e4a97cb9Eb3880DAe",

		/** ShipShop - Buy ships with USDC (UUPS proxy) */
		shipShop: "0xDf175AD45C001B0943F990d815665D28c6F425B3",
	}
} as const;

/** Get contracts for current network */
export function getContracts(chainId: number) {
	switch (chainId) {
		case BASE_SEPOLIA_CHAIN_ID:
			return CONTRACTS.baseSepolia;
		default:
			throw new Error(`Unsupported chain ID: ${chainId}`);
	}
}

/** Pre-TGE specific contract addresses */
export const PRE_TGE_CONTRACTS = {
	chainId: BASE_SEPOLIA_CHAIN_ID,
	voidToken: CONTRACTS.baseSepolia.voidToken,
	shipNFT: CONTRACTS.baseSepolia.shipNFT,
	preTgeFarming: CONTRACTS.baseSepolia.preTgeFarming,
	shipShop: CONTRACTS.baseSepolia.shipShop,
	usdc: CONTRACTS.baseSepolia.usdc,
} as const;
